
/**
 *Global Sales Steps
 *
 * @export
 */
export enum SaleSteps {
  DeviceInfo = 1,
  SelectPlan = 2,
  CustomerInfo = 3,
  QuestionAnswer = 4,
  PaymentInfo = 5,
  Review = 6,
  Confirmation = 7
}



/**
 *Local stepper steps ( To refer to the global steps please use @SalesSteps)
 *
 * @export
 */
export enum StepperSteps {
  DeviceInfo = 0,
  SelectPlan = 1,
  CustomerInfo = 2,
  QuestionAnswer = 3,
  PaymentInfo = 4,
  Review = 5,
  Confirmation = 6
}


/**
 *Local stepper steps ( To refer to the global steps please use @SalesSteps)
 *
 * @export
 */
export enum PreneedSalesSections {
  None = -1,
  PreQuestions = 0,
  HealthQuestionsPartA = 1,
  HealthQuestionsPartB = 2,
  RateStep = 3,
  ReplacementStep = 4,
  ProposedInsuredStep = 5,
  SecondaryAddresseeStep = 6,
  OwnerInformationStep = 7,
  BeneficiaryStep = 8,
  CurrentPhysicianStep = 9,
  PaymentInformationStep = 10,
  AgentInformationStep = 11,
  ReviewAndSignStep = 12,
  ConfirmationStep = 13,
  ApplicationHealthQpartA,
  ApplicationHealthQpartB,
  OptionalHealthQuestions = 16,
  RateStepACC = 17,
  BeneficiaryStepACC = 18
}

/**
 *Global Event Types
 *
 * @export
 */
 export enum EventTypes {
  Continue = 1,
  Back = 2,
  Cancel = 3
}

